import { EXPIRY_DATA_VALIDATOR } from '@constants';
import { ValidationResult } from 'hooks';

export const expiryDateValidator = (expiryDate: string): ValidationResult => {
  const result = {
    isValid: true,
    error: ''
  };

  const isValid = EXPIRY_DATA_VALIDATOR.test(String(expiryDate));
  if (!isValid) {
    result.error = 'Invalid Expiry Date';
    result.isValid = false;
  }

  return result;
};
